import BaseAPIService from '../base/base-api-service';
import LocationModel from 'src/model/location.model';

class WarehouseService extends BaseAPIService<LocationModel> {
  public endpoint: string = '/navapp/v1/warehouse/warehouses';

  constructor() {
    super(LocationModel);
  }

  public getWarehouses(): Promise<LocationModel[]> {
    return this.getByParams(this.endpoint, {}, {});
  }
}

const warehouseServiceInstance = new WarehouseService();
Object.freeze(warehouseServiceInstance);

export default warehouseServiceInstance;
